import { initUhsOptions } from 'uhs-options.dom'

// Auto-init — ES modules are deferred, so DOM is already parsed.
// Widgets (dropdown, tooltip) manage their own outside-click / Escape
// behaviour, so there's nothing global to wire up here.
const root = document.querySelector('[data-uhs-options]');
if (root) {
  try {
    initUhsOptions(root);
  } catch (err) {
    console.error('UHS init failed:', err);
    const errEl = root.querySelector('[data-uhs-errors]');
    if (errEl) {
      errEl.textContent = 'Product options failed to load. Please refresh the page. If the issue persists, contact Upper Hand Holsters.';
    }
  }
}
